export const visit = (vm, at) => {
at({ "no-no": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Beklager, vi kunne ikke bekrefte epostadressen din." } } } });
};